import axios from 'axios'
import { Message} from 'element-ui'

const baseUrl = process.env.VUE_APP_BASE_SCRMAPI;
const requestscrm = (url, method, data) => {
    var header = {
        "Authorization": "",
    }
    return new Promise((resolve, reject) => {
       if (method === 'GET') {
            axios({
                    headers:header,
                    method: method,
                    url: baseUrl + url,
                    params: data
                }).then(res => {
                    if (res.status === 200) {
                        resolve(res);
                    } else {
                        resolve(res);
                        Message.error('网络错误');
                    }
                })
                .catch(err => {
                    reject(err); //失败
                });
        } else if (method === 'POST') {
            axios({
                    headers:header,
                    method: method,
                    url: baseUrl + url,
                    data: data
                }).then(res => {
                    if (res.status === 200) {
                        resolve(res);
                    } else {
                        resolve(res);
                        Message.error('网络错误');
                    }
                })
                .catch(err => {
                    reject(err); //失败
                });
        }
    })
}
export default requestscrm